import React from 'react';
import styled from 'styled-components';
import { Card, Typography, Grid, Box, Avatar, Container, Paper} from '@mui/material';
//import {CardContent} from '@mui/material';
import { useSelector } from 'react-redux';

const StudentProfile = () => {
  const { currentUser, response, error } = useSelector((state) => state.user);

  if (response) { console.log(response); }
  else if (error) { console.log(error); }

  const sclassName = currentUser.sclassName;
  const studentSchool = currentUser.school;

  return (
    <Container maxWidth="md" sx={{ padding: 2 }}>
      <StyledPaper elevation={5}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              <Avatar 
                alt="Student Avatar" 
                sx={{ width: 150, height: 150, bgcolor: 'teal', color: 'gold', fontSize: 40, fontWeight: 'bold' }}>
                {String(currentUser.name).charAt(0)}
              </Avatar>
            </Box>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'teal' }}>
              {currentUser.name}
            </Typography>
            <Typography variant="subtitle1" sx={{ color: 'gold', fontWeight: 'medium' }}>
              Student Roll No: {currentUser.rollNum}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'teal' }}>
              Class: {sclassName.sclassName}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'gold' }}>
              School: {studentSchool.schoolName}
            </Typography>
          </Grid>
        </Grid>
      </StyledPaper>
      <Card sx={{ backgroundColor: 'teal', color: 'white', borderRadius: 3, boxShadow: 4 }}>
        {/* <CardContent>
          <Typography variant="h6" gutterBottom sx={{ color: 'gold' }}>
            Personal Information
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1"><strong>Date of Birth:</strong> ...</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1"><strong>Gender:</strong> ...</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1"><strong>Email:</strong> ...</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1"><strong>Phone:</strong> ...</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1"><strong>Address:</strong> ...</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1"><strong>Emergency Contact:</strong> ...</Typography>
            </Grid>
          </Grid>
        </CardContent> */}
      </Card>
      {/* <Box mt={3} textAlign="center">
        <StyledButton variant="contained">Edit Profile</StyledButton>
        <StyledButton variant="outlined">View Grades</StyledButton>
      </Box> */}
    </Container>
  );
};

export default StudentProfile;

const StyledPaper = styled(Paper)`
  padding: 20px;
  margin-bottom: 20px;
  background: linear-gradient(135deg, teal 30%, gold 100%);
  color: white;
  border-radius: 10px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }
`;

// const StyledButton = styled(Button)`
//   margin: 10px;
//   padding: 10px 20px;
//   font-weight: bold;
//   color: white !important;
//   background: teal !important;
//   border-radius: 25px;
//   transition: all 0.3s ease-in-out;

//   &:hover {
//     background: gold !important;
//     color: teal !important;
//     transform: scale(1.1);
//   }
// `;
